import { useCallback } from "react";
import { v4 as uuid } from "uuid";
import { useCommand } from "@lookiero/messaging-react";
import { createModalNotification } from "../../../../domain/notification/command/createModalNotification";
const useCreateModalNotification = ({ contextId, logger }) => {
    const [commandBus, status] = useCommand({ contextId });
    const create = useCallback(async ({ aggregateId, titleI18nKey, bodyI18nKey, acceptI18nKey }) => {
        try {
            await commandBus(createModalNotification({
                aggregateId: aggregateId || uuid(),
                titleI18nKey,
                bodyI18nKey,
                acceptI18nKey,
            }));
        }
        catch (error) {
            logger.captureException(error);
        }
    }, [commandBus, logger]);
    return [create, status];
};
export { useCreateModalNotification };
